import * as React from "react";

import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import WaitOrderCard from '../components/WaitOrderCard.jsx'

import * as ApiCall from '../ApiCall.jsx';


const NOTIFICATION_INTERVAL = 6000;


// displays the orders with dishes to come
// staff can see what dishes are cooking still
// what are ready to be served, and can check off dishes when they are served
export default function WaitOrders({setNotification}) {

  const [state, setState] = React.useState("loading");
  const [numReady, setNumReady] = React.useState(0);
  const [orders, setOrders] = React.useState([]);

  function getOrders() {
    ApiCall.get("/order/remainingOrders")
      .then((recievedOrders) => {
    
        let orderList = []
        for (let i = 0; i < recievedOrders.length; i++) {
          orderList.push(recievedOrders[i]);
        }
  
        //sort by oldest order
        orderList.sort((a, b) => {
          return (new Date(a.startTime) - new Date(b.startTime));
        });
        
        setNumReady(sumReady(orderList));
        setOrders(orderList); 
        setState("success");
      })
      .catch((msg) => { alert("Failed to get orders: " + msg)} )
  }

  

  //calculates the number of ready orders in the given object
  function sumReady(os) {
    let sum = 0;
    for (const [oId, oInfo] of Object.entries(os)) {
      for (const [dId, dInfo] of Object.entries(oInfo["dishes"])) {
        if (dInfo["status"] > 1) { sum = sum + 1 }
      }
    }
    return sum;
  }


  //do this guy, else first load takes NOTIFICAATION_INTERVAL amount of time
  React.useEffect(() => { 
    getOrders();
  }, []);

  //regularly gets orders again to see if any new ones
  React.useEffect(() => {
    const interval = setInterval(() => {
      getOrders();
    }, NOTIFICATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => { 
    setNotification(true);
  }, [numReady]);

  function removeOrder(id) {
    ApiCall.post("/wait_staff/serveOrder", "orderId=" + id)
    .then(() => {
      for (let i = 0; i < orders.length; i++) {
        if (orders[i].id == id) {
          let copy = [...orders];
          copy.splice(i, 1);
          setOrders(copy);
        }
      }
    })
    .catch((msg) => {alert("failed to close order: " + msg)});    
  }



  if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  else if (state === "success") {
    return (
      <Container sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' , gap: 1, pt: 2}}>
        {
          orders.map((order) => (
            <WaitOrderCard key={order.id} orderInfo={order} completeOrder={() => {removeOrder(order.id)}}></WaitOrderCard>
          ))
        }
      </Container>
    );
  }
  
  
};
